import Store from '../../components/store';

export default function setMixAndMatch() {
  const section = document.querySelector('[data-mix-section]');
  if (!section) return;

  const products = section.querySelectorAll('.product-block');
  const inputsSku = section.querySelectorAll('input[name="sku"]');
  const titles = section.querySelectorAll('[data-mix-title]');
  const wrapper = section.querySelector('[data-mix-wrapper]');
  const toggles = section.querySelectorAll('[data-mix-toggle]');
  const finalResult = section.querySelector('[data-mix-final]');
  const symbol = section.querySelector('[data-mix-symbol]');
  const results = section.querySelectorAll('[data-mix-result]');
  const addButton = section.querySelector('[data-mix-button]');

  if (!wrapper || !finalResult || !addButton) return;

  function clearResult() {
    const span = finalResult.querySelector('.result-inner > span');
    const text = finalResult.querySelector('.result-inner > p');
    if (span) span.remove();
    if (text) text.remove();

    finalResult.classList.remove('-active');
    if (symbol) symbol.classList.remove('-active');
    wrapper.classList.remove('-checked');
  }

  function resetSelection(product, index) {
    product.classList.remove('-active');
    product.setAttribute('data-mix', '');

    const toggle = toggles[index];
    if (toggle) {
      toggle.classList.remove('-active');
      const form = toggle.closest('.form');
      if (form) form.querySelector('input[name="sku"]').value = '';
    }

    if (inputsSku[index]) inputsSku[index].value = '';
    if (titles[index]) titles[index].innerHTML = `Vela ${index + 1}`;

    clearResult();
  }

  function selectProduct(product) {
    const sku = product.getAttribute('data-sku');
    if (!sku) return;

    const freeIndex = Array.from(inputsSku).findIndex((input) => !input.value);
    if (freeIndex === -1) return;

    product.classList.add('-active');
    product.setAttribute('data-mix', freeIndex);

    inputsSku[freeIndex].value = sku;
    if (titles[freeIndex]) titles[freeIndex].innerHTML = product.getAttribute('data-name');

    const toggle = toggles[freeIndex];
    if (toggle) toggle.classList.add('-active');

    if (inputsSku[0].value && inputsSku[1].value) {
      wrapper.classList.add('-checked');

      const refA = section.querySelector('.product-block[data-mix="0"]')?.getAttribute('data-ref');
      const refB = section.querySelector('.product-block[data-mix="1"]')?.getAttribute('data-ref');

      results.forEach((result) => {
        const combination = result.getAttribute('data-mix-combination');
        if (!combination || !refA || !refB) return;

        const combinationRefs = combination.split('+').map((ref) => ref.trim());

        if (combinationRefs.includes(refA) && combinationRefs.includes(refB)) {
          let title = result.getAttribute('data-mix-text') || '';
          let description = '';

          if (title.includes('/')) {
            const parts = title.split('/');
            title = parts[0];
            description = parts[1];
          }

          if (description) {
            const p = document.createElement('p');
            p.innerHTML = description;
            finalResult.querySelector('.result-inner').prepend(p);
          }

          const span = document.createElement('span');
          span.innerHTML = title;
          finalResult.querySelector('.result-inner').prepend(span);
        }
      });

      if (symbol) symbol.classList.add('-active');
      finalResult.classList.add('-active');

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  products.forEach((product) => {
    product.addEventListener('click', (e) => {
      if (e.target.closest('a[href]')) return;

      if (product.classList.contains('-active')) {
        const index = Number(product.getAttribute('data-mix'));
        resetSelection(product, index);
      } else {
        selectProduct(product);
      }
    });
  });

  toggles.forEach((toggle, index) => {
    toggle.addEventListener('click', () => {
      if (!toggle.classList.contains('-active')) return;

      const product = section.querySelector(`.product-block[data-mix="${index}"]`);
      if (product) resetSelection(product, index);
    });
  });

  const mainForm = section.querySelector('[data-form-product-mix]');
  const boxResponse = finalResult.querySelector('.msg-response');

  addButton.addEventListener('click', async () => {
    if (addButton.classList.contains('-adding')) return;
    if (!inputsSku[0].value || !inputsSku[1].value) return;

    addButton.classList.add('-adding');

    const data = {
      items: [
        { sku: inputsSku[0].value, quantity: 1, customizations: [] },
        { sku: inputsSku[1].value, quantity: 1, customizations: [] },
      ],
    };

    try {
      const response = await fetch('/carrinho/adicionar/kit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const html = await response.text();
        Store.addItemResult('produto-adicionado', html, boxResponse, mainForm);
      } else {
        console.error(`mixAndMatch: erro ao adicionar os produtos ao carrinho. Status ${response.status}`);
        Store.addItemResult('erro-adicionar', null, boxResponse, mainForm);
      }
    } catch (error) {
      console.error('mixAndMatch: erro ao adicionar os produtos ao carrinho', error);
      Store.addItemResult('erro-adicionar', null, boxResponse, mainForm);
    } finally {
      addButton.classList.remove('-adding');
    }
  });
}
